import React, { FC } from 'react';

import { TooltipProps as MuiTooltipProps, Theme } from '@mui/material';
import {CustomTooltipProps} from '../types'

/* styled */
import { StyledTooltip } from './styled';
import { useTheme } from '@mui/styles';

export const Tooltip: FC<CustomTooltipProps> = (props) => {
  const theme: Theme = useTheme();
  return <StyledTooltip
            {...props}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: 256,
                  fontSize: `11px`,
                  borderRadius:`2px`,
                  bgcolor:
                    props.color === 'primary' ?  `#2763ea`
                  : props.color === 'secondary' ? `#6f6f83`
                  : props.color === 'warning' ?  `#f57f00`
                  : props.color === 'error' ?  `#ef4116`
                  : props.color === 'success' ?  `#2f9812`
                  : props.color === 'grayscale' ?  `#686868`
                  : props.color === 'grayscaleSecondary' ? `#11193f`
                  : `#6f6f83`,
                  '& .MuiTooltip-arrow': {
                    color:
                      props.color === 'primary' ?  `#2763ea`
                        : props.color === 'secondary' ? `#6f6f83`
                          : props.color === 'warning' ?  `#f57f00`
                            : props.color === 'error' ?  `#ef4116`
                              : props.color === 'success' ?  `#2f9812`
                                : props.color === 'grayscale' ?  `#686868`
                                  : props.color === 'grayscaleSecondary' ? `#11193f`
                                    : `#6f6f83`,
                  },
                  // bgcolor:
                  //   props.color === 'primary' ?  theme.palette.primary[300]
                  // : props.color === 'secondary' ? theme.palette.secondary[600]
                  // : props.color === 'warning' ?  theme.palette.warning[500]
                  // : props.color === 'error' ?  theme.palette.error[300]
                  // : props.color === 'success' ?  theme.palette.success[300]
                  // : props.color === 'grayscale' ?  theme.palette.grayscale[300]
                  // : props.color === 'grayscaleSecondary' ? theme.palette.grayscaleSecondary[300]
                  // : theme.palette.secondary[600],
                  // '& .MuiTooltip-arrow': {
                  //   color: props.color === 'primary' ?  theme.palette.primary[300]
                  //     : props.color === 'secondary' ? theme.palette.secondary[300]
                  //     : props.color === 'warning' ?  theme.palette.warning[500]
                  //     : props.color === 'error' ?  theme.palette.error[300]
                  //     : props.color === 'success' ?  theme.palette.success[300]
                  //     : props.color === 'grayscale' ?  theme.palette.grayscale[300]
                  //     : props.color === 'grayscaleSecondary' ? theme.palette.grayscaleSecondary[300]
                  //     : theme.palette.secondary[600]
                  // },
                },
              },
            }}
  >
           {props.children}
  </StyledTooltip>;
};

// export const Tooltip: FC<CustomTooltipProps>  = ({ className, ...props }) => {
//   return
//   <StyledTooltip open={true} {...props} {...props} classes={{ tooltip: className }} >{props.children}</StyledTooltip>
// };
